import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Config from "../Config";
import { useAuthHandling } from "../useAuthhandling";
import Toastmodal from "../Toastmodal";
import Cookies from "js-cookie";
import Deletemodal from "../Deletemodal";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Nodatafound from "../Nodatafound";


function Propertylistrent() {

  const [bannerdata, setBannerdata] = useState([]);
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [bannertype, setBannertype] = useState('');
  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");
  const [type,setType]=useState('sell');
  const [rent,setRent]=useState([]);
  const [pageCount, setpageCount] = useState([]);
  const [pagenum,setPagenum]=useState(1);
  const[pageindex,setPageindex]=useState(1);

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/rent/get-properties?page=1`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const data = await res.json();
    if (res.status === 200 ) {
      setBannerdata(data.data[0].data);
      setpageCount(data.data[0].totalPages);

    } else if(res.status===401) {
      handleUnauthorized();
      getinfo();
    }
  };
  useEffect(() => {
    getinfo();
  }, []);


  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);
    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/rent/delete-property/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (response.status === 200) {
      setToastmodal(true);
      setToastmessage("Sucessfully Deleted");
      setToasttype("success");
      setToastlarge(false);
      getinfo ()
       } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
      const deletedata = await response.json();
      setToastmodal(true);
      setToastmessage(response.message);
      setToasttype("error");
      setToastlarge(true);
    }
  };

  const fetchComments = async (page) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/rent/get-properties?page=${page}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const data = await res.json();
    if (res.status === 200 ) {
      return data.data[0].data;

    } else if(res.status===401) {
      handleUnauthorized();
      fetchComments(page);
    }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPageindex(1);

      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setBannerdata(commentsFormServer);
    }
    else{
      let currentPage = data.selected + 1;
      setPageindex(currentPage);

      setPagenum(data);
      const commentsFormServer = await fetchComments(currentPage);
  
      setBannerdata(commentsFormServer);
    }
    // setLoading(false);

    window.scrollTo(0, 0);

  };

  let handleInputs = async(id,val) => {

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/rent/update-rent-property-status/${id}`,
      {
        method: "PUT",
        body: JSON.stringify({
          status:val
       }),
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",

        },
      }
    );


    if (response.status === 200 ) {
      const verifydata = await response.json();
      toast.success("Property status Updated!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handlePageClick(pagenum);
      <ToastContainer />;

    } 
    else if(response.status === 401){
      handleUnauthorized();
      handleInputs(id);
    }
    else {
      toast.error("Something went wrong!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      <ToastContainer />;
    }
  }

  let handlefeature = async(id,val) => {

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/rent/update-property-featured/${id}`,
      {
        method: "PUT",
        body: JSON.stringify({
          featured:val
       }),
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",

        },
      }
    );


    if (response.status === 200 ) {
      const verifydata = await response.json();
      toast.success("Property feature Updated!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handlePageClick(pagenum);
      <ToastContainer />;

    } 
    else if(response.status === 401){
      handleUnauthorized();
      handleInputs(id);
    }
    else {
      toast.error("Something went wrong!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      <ToastContainer />;
    }
  }

  let handlesold = async(id,val) => {

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/rent/sold-out-property/${id}`,
      {
        method: "POST",
       
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",

        },
      }
    );


    if (response.status === 200 ) {
      const verifydata = await response.json();
      toast.success("Property feature Updated!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handlePageClick(pagenum);
      <ToastContainer />;

    } 
    else if(response.status === 401){
      handleUnauthorized();
      handleInputs(id);
    }
    else {
      toast.error("Something went wrong!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      <ToastContainer />;
    }
  }

  return (
    <div>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin stretch-card">
                <div className="col-12">
                  <div className="card pb-4">
                    <div className="card-body">
                      <h4 className="card-title pb-2">Property List</h4>
                      
                      <div className='user_all_list-head '>
                    
                                <Link className='user_all_list-head_a' to="/property-list">Sell List</Link>

                                <Link className='user_all_list-head_a' to="/property-list-rent">Rent List</Link>

                            </div>
                      <div
                        id="js-grid"
                        className="pt-3 jsgrid"
                        style={{
                          position: "relative",
                          height: 516,
                          width: "100%",
                        }}
                      >
                        <h4 className="card-title">Rent List</h4>
                        <div className="table-responsive pt-3 mb-3">
                        {bannerdata?.length>0?
                          <div className="jsgrid-grid-header jsgrid-header-scrollbar">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Type</th>
                                  <th>Property ad title</th>
                                  <th>Status</th>
                                  <th>Feature</th>
                                  <th>Sold Out</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bannerdata.map((element, i) => {
                                  return (
                                    <>
                                      <tr>
                                      <th scope="row">{pageindex===1 ? i+1: (pageindex-1) * 10 + i +1}</th>
                                        <td>{element.propertyType}</td>
                                        <td>{element.propertyAdTitle}</td>
                                      
                                        <td><select className="form-select" name="status" value={element.status}  onChange={(e)=>handleInputs(element._id,e.target.value)}>
                                          <option value='Pending'>Pending</option>
                                          <option value='Listed'>Listed</option>
                                          <option value='Unlisted'>Un listed</option>

                                        </select></td>
                                        {/* <td><select className="form-select" name="status" value={element?.featured}  onChange={(e)=>handlefeature(element._id,e.target.value)}>
                                          <option value=''>Select</option>
                                          <option value={true}>Yes</option>
                                          <option value={false}>No</option>
                                     

                                        </select></td> */
                                        
                                        }

<td>
                                  <span
                        className="form-checks form-switch form-switch-lg mb-3"
                        dir="ltr"
                      >
                                    <input
                          type="checkbox"
                          name="status"
                          className="form-check-input "
                          value={element.featured}
                           checked={element.featured === true ? true : false}
                           onChange={(e)=>handlefeature(element._id,e.target.value)}
                        />
                        </span>
                        </td>
                                     <td>
                                  <span
                        className="form-checks form-switch form-switch-lg mb-3"
                        dir="ltr"
                      >
                                    <input
                          type="checkbox"
                          name="soldOut"
                          className="form-check-input "
                          value={element.soldOut}
                           checked={element.soldOut === true ? true : false}
                           onChange={(e)=>handlesold(element.propertySlug)}
                        />
                        </span>
                        </td>

                                      
                                        <td className="actions_td">
                                          <Link
                                          to="#"
                                          className="action_icons"
                                             onClick={() => tog_animationFlip(element._id)}
                                          >
                                            <i className="fa-solid fa-trash" />
                                          </Link>
                                         
                                            <Link to={"/edit-property/" + element._id}  state={{
                                     
                                     level: 'rent',
                                   }}  className="action_icons">
                                        
                                            <i className="fa-solid fa-pen" />
                                            </Link>
                                        
                                         
                                             <Link to={"/property-view/" + element._id}   state={{
                                     
                                     level: 'rent',
                                   }} 
                                   className="action_icons">
                                            
                                   
                                            <i className="fa-solid fa-eye" />
                                            </Link>
                                          
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                            </table>
                            <ToastContainer />
                            {pageCount > 1 ? (
                          <ReactPaginate
                            previousLabel={"previous"}
                            nextLabel={"next"}
                            breakLabel={"..."}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={
                              "pagination justify-content-center"
                            }
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        ) : (
                          ""
                        )}
                          </div>
                          :
                          <Nodatafound/>
                        }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}


    {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Property"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Propertylistrent;
